import React, { useState } from 'react';
import AlgoliaSearch from '../../../../../components/presentational/AlgoliaSearch';
import Spacer from '../../../../../components/presentational/Spacer';
import styled, { StylesProps } from '../../../../../lib/styles';
import algoliaBlockStyles from './AlgoliaBlock_styles';

export interface AlgoliaBlockData {
  type: 'indexed_search_block';
  title: string;
  sub_title: string;
  search_index: string;
}
export interface AlgoliaBlockProps {
  block: AlgoliaBlockData;
}

const AlgoliaBlock = ({
  block: { title, sub_title, search_index },
  styles,
}: AlgoliaBlockProps & StylesProps<typeof algoliaBlockStyles>) => {
  return (
    <div className={`algolia-search-block-container ${styles.container}`}>
      <Spacer width={1160} space={['m', 'l']}>
        <Spacer space={['s', 'm']}>
          {title ? (
            <div className="d-flex algolia-search-block-title">
              <h1>{title}</h1>
            </div>
          ) : (
            <></>
          )}

          {sub_title ? <h3>{sub_title}</h3> : <></>}
          <AlgoliaSearch search_index={search_index} />
        </Spacer>
      </Spacer>
    </div>
  );
};
export default styled(algoliaBlockStyles)(AlgoliaBlock);
